var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.needHeader)?_c('page-header'):_vm._e(),_c('router-view'),(_vm.$route.meta.needFooter)?_c('page-footer'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }